import React, { PureComponent } from 'react'
import PropTypes                from 'prop-types'
import classNames               from 'class-names'
import './index.less'
import explain_icon from '../../assets/svg/explain_icon.png'
class Section extends PureComponent {

  static propTypes = {
    title: PropTypes.string,
    showMore: PropTypes.bool,
    showMoreText: PropTypes.string,
    maxHeight: PropTypes.string,
    className: PropTypes.string,
  }

  state = {
    animationState: 0,
    positions: null,
  }

  handleExpand() {
    this.setState({
      animationState: 1,
    })
  }

  handleShrink() {
    this.setState({
      animationState: 0
    });
    let expandable= document.getElementsByClassName('expandable')[0];
    window.scrollTo(0,expandable.offsetTop);
  }

  getStyle() {
    const { showMore, maxHeight } = this.props
    const { animationState } = this.state
    if (showMore) {
      switch (animationState) {
        case 1:
          return {
            height: this.refs.container.scrollHeight,
            overflow: 'hidden',
          }
        default:
          return {
            height: maxHeight,
            overflow: 'hidden',
          }
      }
    } else {
      return {}
    }
  }

  render() {
    const { title, className, children, showMore, showMoreText, hideMoreText ,explain} = this.props
    const { animationState } = this.state
    const classes = ({
      'without-title': !Boolean(title),
      'section': true,
    })
    if (className) {
      classes[className] = true
    }
    return (
      <section className={classNames(classes)}>
        {title && <h2>{title}{explain && <img src={explain_icon} alt="" width='13px' style={{marginLeft:'5px'}} onClick={this.props.onExplainClick}/>}</h2>}
        <div className="expandable" ref="container" style={this.getStyle()}>{children}</div>
        {showMore && (animationState
            ? <div className="btn-show-more-reset" onClick={this.handleShrink.bind(this)}>
              {hideMoreText}
              <svg className="icon icon-indicator_5">
                <use xlinkHref="#icon-indicator_5"></use>
              </svg>
            </div>
            : <div className="btn-show-more" onClick={this.handleExpand.bind(this)}>
              {showMoreText}
              <svg className="icon icon-indicator_4">
                <use xlinkHref="#icon-indicator_4"></use>
              </svg>
            </div>
        )}
      </section>
    )
  }
}

Section.defaultProps = {
  title: '',
  showMore: false,
  showMoreText: '阅读更多',
  hideMoreText: '收起',
  maxHeight: '256px',
}

export default Section



// WEBPACK FOOTER //
// ./src/components/Section/index.js